'use client';

import { useRef, useEffect } from 'react';
import { cn } from '@/lib/utils';
import { StarIcon } from '@/components/icons/star';

interface ScrollingTextProps {
  items: string[];
  className?: string;
}

const ScrollingText = ({ items, className }: ScrollingTextProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current || !contentRef.current) return;

    const container = containerRef.current;
    const content = contentRef.current;
    // Calcoliamo la larghezza di una singola copia (dividiamo per 3 perché abbiamo 3 copie)
    const contentWidth = content.offsetWidth / 3;

    // Imposta la larghezza esatta per l'animazione
    container.style.setProperty('--content-width', `-${contentWidth}px`);
  }, [items]);

  const renderContent = (keyPrefix: string) => (
    <>
      {items.map((item, index) => (
        <div key={`${keyPrefix}-${index}`} className='flex items-center'>
          <span className='text-white text-[2.5rem] font-normal whitespace-nowrap'>{item}</span>
          <div className='mx-20 shrink-0'>
            <StarIcon className='shrink-0 text-white' />
          </div>
        </div>
      ))}
    </>
  );

  return (
    <div className={cn('relative z-30 w-full overflow-hidden bg-brand-violet-500 py-4', className)} aria-hidden='true'>
      <div ref={containerRef} className='scrolling-text-container flex items-center will-change-transform'>
        <div ref={contentRef} className='flex items-center'>
          {renderContent('first')}
          {renderContent('second')}
          {renderContent('third')}
        </div>
      </div>
    </div>
  );
};

export default ScrollingText;
